/* eslint-disable no-unused-vars */
export enum DATA_EVENTS {
    BUSINESS_UNIT_CHANGED = 'BUSINESS_UNIT_CHANGED',
    TOP_MENU_COLOR_CHANGED = 'TOP_MENU_COLOR_CHANGED',
    NOTIFICATION_BELL_CLICKED = 'NOTIFICATION_BELL_CLICKED',
    NOTIFICATION_BELL_ITEM_READ = 'NOTIFICATION_BELL_ITEM_READ',
    NOTIFICATION_BELL_ITEM_UNREAD = 'NOTIFICATION_BELL_ITEM_UNREAD',
    DEFAULT_LANDING_PAGE_CHANGED = 'DEFAULT_LANDING_PAGE_CHANGED',
    SOURCES_ADDED = 'SOURCES_ADDED',
    SOURCES_REMOVED = 'SOURCES_REMOVED',
}
